<template>
  <div class="carousel-wrap" :style="{background: 'url(' + advBgImage + ') no-repeat center center', backgroundSize:'cover'}" >
    <div class="bg-cover"></div>
    <el-carousel :interval="3000" arrow="always" :class="carouselClass"  :height="carouseHeight"  indicator-position="none">
      <el-carousel-item v-for="item in itemList" :key="item.id">
        <a :href="item.address" class="imgbox" :style="{backgroundImage: 'url(' + (item.image) + ')', backgroundSize:'100% 100%'}"  >
          <div class="carousel-name">
            <h5 class="img-name">{{ item.name }}</h5>
          </div>
        </a>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>


<script>
import { pageSetting, GetCarouselImg } from "@/request/api";

export default {
  name: "Carousel",
  // props: [ 'advBgImage'],
  data() {
    return {
      itemList: [],
      advBgImage: "",
      carouselClass: {
        carouselBox: window.innerWidth > 920,
      },
      carouseHeight: window.innerWidth > 920 ? '420px' : '190px'
    };
  },
  mounted() {
    pageSetting().then(res => {
      if (res.success) {
        this.advBgImage = res.data.advBgImage;
      }
    });
    // this.GetCarouselImg();

    GetCarouselImg().then(res => {
        if (res.success && res.data.length) {
         for (let i=0; i < res.data.length; i++){
            this.itemList.push(res.data[i])
          }
        }
      })
  },
  method: {
    //    GetCarouselImg: function() {
    //   this.itemList = [];
    //   GetCarouselImg().then(res => {
    //     if (res.success && res.data.length) {
    //      for (let i=0; i < res.data.length; i++){
    //         this.itemList.push(res.data[i])
    //       }
    //     }
    //   })
    // },
  }
  
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped lang="less">

.carousel-wrap {
  // position: absolute;
  width: 100%;
  height: 190px;
  background-size: cover!important;
}
.carouselBox {
    width: 920px;
    height: 420px;
    left: calc(50% - 460px);
}
.imgbox {
  display: inline-block;
  width: 100%;
  height: 100%;
 
} 
.bg-cover {
  position: absolute;
  right: 0;
  top: 225px;
  width: 100%;
  // height: 100%;
  height: auto;
  background: #000;
  opacity: .5;
}
.carousel-name {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 40px;
  margin: 0;
  background: #000;
  opacity: .5;
  .img-name {
  color: #fff;
    margin: 0;
    line-height: 40px;
    font-size: 20px;
    text-align: center;
  }
}

@media screen and (min-width: 920px) {
  .carousel-wrap {
    height: 420px;
  }
  
}
</style>
